import { ElementRef, ViewChild } from '@angular/core';
import { TemplateRef } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators } from '@angular/forms';
import {TrackingService} from '../../services/tracking.service';
import {Track} from '../../interfaces/track';
import { Observable } from 'rxjs';
import { NgxNavigationWithDataComponent } from 'ngx-navigation-with-data';
import {DataService} from '../../services/data.service';
import {Status} from '../../interfaces/status';

var $:any;
@Component({
  selector: 'app-tracking-manager',
  templateUrl: './tracking-manager.component.html',
  styleUrls: ['./tracking-manager.component.sass']
})
export class TrackingManagerComponent implements OnInit {
  @ViewChild('ModalNew') modal: any;
  
  public p = 0;
  public closeResult: string  = "";
  public titleModal:string = "Nuevo Formulario";
  public listTrack: Observable<Track[]>;
  public status:Status[];

  public sendForm = this.fb.group({
    idData: [{value: '', disabled: true}, Validators.required],
    dateStart:[''],
    cityStart:[''],
    nameStart:[''],
    dateEnd:[''],
    cityEnd:[''],
    nameEnd:[''],
    description:[''],
    status:['']
  });


  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private ts: TrackingService,
    private navCtrl: NgxNavigationWithDataComponent,
    private dS:DataService
    
    ) {  
      this.listTrack = this.ts.listTrackingAll().valueChanges();
      this.status = dS.DATA_STATUS
    }

  ngOnInit(): void {
    
  }
   

  public newData(){
      this.titleModal = "Ingresar Nuevo Valor";
      let id = "FT-" + (new Date()).getTime();
      this.sendForm.get("idData")?.setValue(id);
      this.sendForm.get("dateStart")?.setValue("");
      this.sendForm.get("cityStart")?.setValue("");
      this.sendForm.get("nameStart")?.setValue("");
      this.sendForm.get("dateEnd")?.setValue("");
      this.sendForm.get("cityEnd")?.setValue("");
      this.sendForm.get("nameEnd")?.setValue("");
      this.sendForm.get("description")?.setValue("");

      this.modalService.open(this.modal,{});
  }

  editData(tr:Track){
    this.titleModal = "Editar";
    this.sendForm.get("idData")?.setValue(tr.id);
    this.sendForm.get("dateStart")?.setValue(tr.dateStart);
    this.sendForm.get("cityStart")?.setValue(tr.cityStart);
    this.sendForm.get("nameStart")?.setValue(tr.nameStart);
    this.sendForm.get("dateEnd")?.setValue(tr.dateEnd);
    this.sendForm.get("cityEnd")?.setValue(tr.cityEnd);
    this.sendForm.get("nameEnd")?.setValue(tr.nameStart);
    this.sendForm.get("status")?.setValue(tr.status);
    this.sendForm.get("description")?.setValue(tr.description);
    this.modalService.open(this.modal);
  }

  showImage(id:any){
    this.navCtrl.navigate('tracking/edit', {id: id});
  }



  onEditSubmit(){
     let v:Track = {
       id:this.sendForm.get("idData")?.value,
       dateStart: this.sendForm.get("dateStart")?.value,
       cityStart: this.sendForm.get("cityStart")?.value,
       nameStart: this.sendForm.get("nameStart")?.value,
       dateEnd: this.sendForm.get("dateEnd")?.value,
       cityEnd: this.sendForm.get("cityEnd")?.value,
       nameEnd: this.sendForm.get("nameEnd")?.value,
       status: this.sendForm.get("status")?.value,
       description: this.sendForm.get("description")?.value,
     }; 

     console.log(this.sendForm.get("dateEnd")?.value);

     this.ts.newTracking(this.sendForm.get("idData")?.value, v).then(v=>{
          this.closeModal()
     });

  }

  public closeModal() {
   this.modalService.dismissAll()
  }



  deleteTrack(id:any){
     this.ts.deleteTracking(id);
  }

  getStatus(statusId:any):string{
    for (var _i = 0; _i < this.status.length; _i++) {
      let value:Status = this.status[_i]
      if(value.id == statusId){return value.name;}
    }
    return ""
 }

}
